import React from 'react';
import { styled } from '@mui/material/styles';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { dateFormat, dayjsLocale } from 'src/utils/dateFormat';

const CustomDatePicker = styled((props) => (
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={dayjsLocale}>
    <DatePicker
      format={dateFormat}
      {...props}
    />
  </LocalizationProvider>
))(({ theme, error }) => ({
  width: '100%',
  '& .MuiInputLabel-root': {
    top: '0px',
  },
  '& .MuiOutlinedInput-root': {
    paddingTop: '9px',
    ...(error && {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.error.main,
      },
    }),
  },
  '& .MuiIconButton-root': {
    top: '-5px',
  },
  '& .MuiOutlinedInput-input': {
    top: '-5px',
    position: 'relative',
    fontSize: '12px',
  },
  '& .MuiInputBase-input': {
    paddingTop: '4px',
    paddingBottom: '4px',
  },
}));

export default CustomDatePicker;